export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || '';
export const REACT_APP_RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export const REACT_APP_SITE_NAME =
    process.env.REACT_APP_SITE_NAME || 'Expert Mining';
